export const Register = "/register";
export const Login = "/login";
export const Page404 = "/404";
export const Page500 = "/505";
export const Dashboard = "/dashboard";

export const NewsList = "/news/list";
export const AddNews = "/news/add";
export const EditNews = "/news/edit";
export const ViewNews = "/news/view/:id";
export const EditNewsId = "/news/edit/:id";

export const ImagesList = "/media/list";
export const AddImages = "/media/add";
export const EditImage = "/media/edit";
export const ViewImages = "/media/view/:id";
export const EditImagesId = "/media/edit/:id";

export const VideoList = "/video/list";
export const AddVideo = "/video/add";
export const EditVideo = "/video/edit";
export const ViewVideo = "/video/view/:id";
export const EditVideoId = "/video/edit/:id";

export const NewCategoryList = "/news/category/list";
export const AddNewsCategory = "/news/category/add";
export const EditNewCategory = "/news/category/edit";
export const EditCategoryId = "/news/category/edit/:id";

export const AppVersionList = "/app/version/list";
export const AddVersion = "/app/version/add";
export const EditVersion = "/app/version/edit";
export const EditVersionId = "/app/version/edit/:id";

export const BrokenRecords = "/app/brokenRecords/add";
export const BrokenRecordsList = "/app/brokenRecords/list";

export const Reports = "/app/reports/list";

export const NotificationList = "/app/notifications/list";
export const AddNotification = "/app/notifications/add";
export const EditNotificationId = "/app/notifications/edit/:id";
export const ViewNotificationId = "/app/notifications/view/:id";

export const UpdateStripList = "/app/update-strip/list";
export const AddUpdateStrip = "/app/update-strip/add";
export const EditUpdateStripId = "/app/update-strip/edit/:id";
export const HeroBannerList = "/app/hero-banner/list";
export const AddHeroBanner = "/app/hero-banner/add";
export const EditHeroBannerId = "/app/hero-banner/edit/:id";

export const EventSpotlightList = "/app/event-spotlight/list";
export const AddEventSpotlight = "/app/event-spotlight/add";
export const EditEventSpotlightId = "/app/event-spotlight/edit/:id";
